// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-shortcuts-sheet {
  position: fixed;
  inset: 0;
  z-index: 1300;
}

.au-shortcuts-sheet__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(0, 0, 0, 0.48);
}

.au-shortcuts-sheet__panel {
  position: absolute;
  top: var(--admin-shell-top);
  right: 0;
  bottom: 0;
  width: min(360px, 100vw);
  display: grid;
  align-content: start;
  gap: var(--admin-s5);
  padding: var(--admin-s6);
  border-left: var(--admin-border-default);
  background: #0d0d0d;
  box-sizing: border-box;
}

.au-shortcuts-sheet__header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: var(--admin-s4);
}

.au-shortcuts-sheet__eyebrow {
  color: var(--admin-text-muted);
  font-size: var(--admin-text-micro);
  font-weight: var(--admin-font-weight-bold);
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.au-shortcuts-sheet__title {
  margin: 6px 0 0;
  color: var(--admin-text-primary);
  font-size: var(--admin-text-lg);
  font-weight: var(--admin-font-weight-semibold);
}

.au-shortcuts-sheet__close {
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--admin-text-secondary);
  font: inherit;
  font-size: var(--admin-text-sm);
  cursor: pointer;
}

.au-shortcuts-sheet__rows {
  display: grid;
  gap: var(--admin-s4);
}

.au-shortcuts-sheet__row {
  display: grid;
  gap: var(--admin-s2);
  padding-bottom: var(--admin-s4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.au-shortcuts-sheet__keys {
  display: flex;
  gap: var(--admin-s2);
}

.au-shortcuts-sheet__description {
  margin: 0;
  color: var(--admin-text-secondary);
  font-size: var(--admin-text-sm);
  line-height: 1.45;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminShortcutsSheet.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;EAC1C,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,+BAA+B;EAC/B,iBAAiB;AACnB","sourcesContent":[".au-shortcuts-sheet {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n}\n\n.au-shortcuts-sheet__backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: rgba(0, 0, 0, 0.48);\n}\n\n.au-shortcuts-sheet__panel {\n  position: absolute;\n  top: var(--admin-shell-top);\n  right: 0;\n  bottom: 0;\n  width: min(360px, 100vw);\n  display: grid;\n  align-content: start;\n  gap: var(--admin-s5);\n  padding: var(--admin-s6);\n  border-left: var(--admin-border-default);\n  background: #0d0d0d;\n  box-sizing: border-box;\n}\n\n.au-shortcuts-sheet__header {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: var(--admin-s4);\n}\n\n.au-shortcuts-sheet__eyebrow {\n  color: var(--admin-text-muted);\n  font-size: var(--admin-text-micro);\n  font-weight: var(--admin-font-weight-bold);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.au-shortcuts-sheet__title {\n  margin: 6px 0 0;\n  color: var(--admin-text-primary);\n  font-size: var(--admin-text-lg);\n  font-weight: var(--admin-font-weight-semibold);\n}\n\n.au-shortcuts-sheet__close {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: var(--admin-text-secondary);\n  font: inherit;\n  font-size: var(--admin-text-sm);\n  cursor: pointer;\n}\n\n.au-shortcuts-sheet__rows {\n  display: grid;\n  gap: var(--admin-s4);\n}\n\n.au-shortcuts-sheet__row {\n  display: grid;\n  gap: var(--admin-s2);\n  padding-bottom: var(--admin-s4);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.au-shortcuts-sheet__keys {\n  display: flex;\n  gap: var(--admin-s2);\n}\n\n.au-shortcuts-sheet__description {\n  margin: 0;\n  color: var(--admin-text-secondary);\n  font-size: var(--admin-text-sm);\n  line-height: 1.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
